const getRandomInt = (min, max) => {
  const isBrowserEnv = typeof window !== 'undefined';
  if(!isBrowserEnv) {
    return 0;
  }
  // Create a Uint32Array of length 1
  const randomArray = new Uint32Array(1);
  // Generate cryptographically secure random values
  window.crypto.getRandomValues(randomArray);
  // Calculate the random number within the range [min, max]
  const randomNum = min + randomArray[0] % (max - min + 1);
  return randomNum;
};

// Get the color index when the style of client doesnt match with the server when the component is not mounted.
const getColorIdx = (index, length) => {
 //returns the remainder left over when  index is divided by length of colors const operand.
  return index % length;
};
module.exports = {getRandomInt, getColorIdx};
